import moment from "moment";

import { Client } from "@seneca/client-library";

import {
  FetchXpChallengesResponseBody,
  JoinXpChallengeRequestBody,
  UserXp,
  XpChallenge
} from "./types";

export default class XpServiceClient extends Client {
  async fetchXP(courseId?: string) {
    const url = `${this.url}/api/xp/me?date="${moment().toISOString()}"${
      courseId ? `&courseId="${courseId}"` : ""
    }`;

    const response = await this.requestMaker.makeRequest(url, {
      method: "GET"
    });

    return response.json as UserXp;
  }

  async fetchXpChallenges() {
    const url = `${this.url}/api/xp-challenges/me`;

    const response = await this.requestMaker.makeRequest(url, {
      method: "GET"
    });

    return response.json as FetchXpChallengesResponseBody;
  }

  async joinChallenge(data: JoinXpChallengeRequestBody) {
    const url = `${this.url}/api/xp-challenges/join`;

    const response = await this.requestMaker.makeRequest(url, {
      method: "POST",
      body: JSON.stringify(data)
    });

    return response.json as XpChallenge;
  }
}
